import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { useEffect } from 'react';
import { AuthenticatedUserProvider } from 'src/contexts/AuthenticatedUserContext';
import { ConfigProvider } from 'src/contexts/ConfigContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { getAuthenticatedSession, getDefaultExperience } from 'src/api/authentication';
import { identifyActor } from '@repo/shared/analytics';
import LayoutWrapper from 'src/layouts/company';
import { hardRedirect } from 'src/utils/hardRedirect';

export const Route = createFileRoute('/company_')({
	component: RouteComponent,
	staleTime: 1000 * 60 * 5,
	loader: async () => {
		const authenticatedSession = await getAuthenticatedSession();
		if (!authenticatedSession.user) {
			throw redirect({
				to: '/authentication/login',
				search: {
					redirect: location.href,
				},
			});
		}

		// When the 2.0 experience is the default, send users to the new company app.
		const experience = await getDefaultExperience();
		if (experience === '2.0') {
			await hardRedirect('/app/company/');
		}

		return { authenticatedSession };
	},
});

const queryClient = new QueryClient();

function RouteComponent() {
	const { authenticatedSession } = Route.useLoaderData();

	useEffect(() => {
		identifyActor(authenticatedSession?.user);
	}, [authenticatedSession?.user?.id]);

	return (
		<QueryClientProvider client={queryClient}>
			<AuthenticatedUserProvider authenticatedSession={authenticatedSession}>
				<ConfigProvider>
					<LayoutWrapper>
						<Outlet />
					</LayoutWrapper>
				</ConfigProvider>
			</AuthenticatedUserProvider>
		</QueryClientProvider>
	);
}
